const homeSteps = [
  {
    content: <h2>Let's begin !</h2>,
    locale: { skip: <strong>SKIP</strong> },
    placement: "center",
    target: "body"
  },
  {
    content: <h2>You can hide or show the left menu from here.</h2>,
    placement: "right",
    target: "#leftMenuToggle",
    title: "First step"
  },
  {
    content: <h2>You can navigate directly to the page where the survey cards are displayed from here.</h2>,
    placement: "right",
    target: "#leftMenuHomeIcon",
    disableSpotlight: true,
    title: "Second step"
  },
  {
    content: <h2>You can also navigate directly to the page where the surveys are listed from here.</h2>,
    placement: "right",
    target: "#leftMenuHomeDirect",
    disableSpotlight: true,
    title: "Third step"
  },
  {
    content: <h2>In this section, you can see shortcuts to different areas where you can create surveys in various ways.</h2>,
    placement: "right",
    target: "#leftMenuSurveyCreationShortcuts",
    disableSpotlight: true,
    title: "Fourth step"
  },
  {
    content: <h2>Here, you can access your notifications and also log out from the application.</h2>,
    placement: "right",
    target: "#leftMenuFooter",
    disableSpotlight: true,
    title: "Fifth step"
  },
  {
    content: <h2>You can adjust the site's theme to dark or light mode as you wish.</h2>,
    placement: "bottom",
    target: "#topMenuThemeMode",
    title: "Sixth step"
  },
  {
    content: <h2>This area shows the surveys available to the user.</h2>,
    placement: "bottom",
    target: "#surveys",
    title: "Seventh step"
  },
  {
    content: <h2>In this section, users can upload their files with survey information to generate a new survey.</h2>,
    placement: "bottom",
    target: "#createFromFile",
    title: "Eighth step"
  },
  {
    content: <h2>In this section, users can generate surveys by utilizing AI assistance.</h2>,
    placement: "bottom",
    target: "#qRobot",
    title: "Ninth step"
  },
  {
    content: <h2>In this section, users can view surveys that are included in the benchmarked data.</h2>,
    placement: "bottom",
    target: "#benchmarked",
    title: "Tenth step"
  },
  {
    content: <h2>By clicking this card, users can create a new blank survey from scratch.</h2>,
    placement: "bottom",
    target: "#createFromScratch",
    title: "Eleventh step"
  },
  {
    content: <h2>By clicking these cards, users can navigate to the detailed view of the selected survey.</h2>,
    placement: "bottom",
    target: "#cardBody",
    title: "Twelfth step"
  },
  {
    content: <h2>Users can duplicate the selected survey by clicking this card.</h2>,
    placement: "bottom",
    target: "#cloneSurvey",
    title: "Thirteenth step"
  },
  {
    content: <h2>Users can delete the selected survey from this section.</h2>,
    placement: "bottom",
    target: "#deleteSurvey",
    title: "Fourteenth step"
  },
  {
    content: <h2>Users can directly navigate to the "Results" section of the survey detail page by clicking here.</h2>,
    placement: "bottom",
    target: "#resultSurvey",
    title: "Fifteenth step"
  },
  {
    content: <h2>Users can directly navigate to the "Insight" section of the survey detail page by clicking here.</h2>,
    placement: "bottom",
    target: "#insightSurvey",
    title: "Sixteenth step"
  },
]
export default homeSteps;
